import { colorOption } from '@/data/optionsConstants';
import moment from 'moment';

export function getOid(v) {
  return v && v._id ? v._id : v;
}

export { getOid as getId };

export function oidEquals(a, b) {
  a = getOid(a);
  b = getOid(b);
  return a === b || (a == null && b == null) || String(a) === String(b);
}

export function openPrintWindow() {
  // Get HTML to print from element
  const prtHtml = document.getElementById('print').innerHTML;

  // Get all stylesheets HTML
  let stylesHtml = '';
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML;
  }

  // Open the print window
  const WinPrint = window.open(
    '',
    '',
    'left=0,top=0,width=700,height=900,toolbar=0,scrollbars=0,status=0',
  );

  WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

  WinPrint.document.close();
  WinPrint.focus();
  WinPrint.print();

  window.onafterprint = function (event) {
    console.log('Event', event);
  };
}

export function colorProportion(cp) {
  return [formatRound(cp.firstRound), formatRound(cp.secondRound)].filter(x => x).join(' ~~> \n');
}

function formatRound(round) {
  if (!round) return '';
  return ['1', '2', '3']
    .map(x => {
      const type = round['type' + x];
      const cX = round['color' + x] || [];
      const uX = round['unit' + x] || [];
      const seq = cX.map((c, i) => c + (uX[i] || '')).join(' + ');
      const typeFormat = {
        hairFront: '(前) {seq}',
        hairTail: '(尾) {seq}',
        full: '(全) {seq}',
        hairRoot: '(根) {seq}',
        washAndDye: '洗補 {seq}',
        top: '(頂) {seq}',
      };
      return (typeFormat[type] || '{seq}').replace('{seq}', seq);
    })
    .filter(x => x)
    .join(' ');
}

export function emptyPaginationResult() {
  return { docs: [], limit: 10, offset: 0, page: 1, pages: 1, total: 0 };
}

export const rule_email = value => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(value) || 'Invalid e-mail.';
};
export const rule_hkid = value => {
  const pattern = /^[A-Z]{1,2}[0-9]{6}\([0-9A]\)$/;
  return pattern.test(value) || 'Invalid HKID.';
};

export function calculateAge(birthDate) {
  const birthDateObj = new Date(birthDate);
  const ageInMs = Date.now() - birthDateObj.getTime();
  const ageInYears = Math.round(ageInMs / (1000 * 60 * 60 * 24 * 365.25));
  return ageInYears;
}

export async function showPdf(api, url, isPrint = false) {
  const pdfArrayBuffer = (await api.get(url, { responseType: 'arraybuffer' })).data;
  const blobPdf = new Blob([pdfArrayBuffer], { type: 'application/pdf' });
  const blobURL = URL.createObjectURL(blobPdf);
  if (isPrint) {
    const win = window.open(
      blobURL,
      '',
      'left=0,top=0,width=594,height=824,toolbar=0,scrollbars=0,status=0',
    );
    setTimeout(() => {
      win.focus();
      win.print();
    }, 500);
  } else {
    const win = window.open(blobURL);
  }
}

export function getBuildVersion() {
  const { time, git } = process.env.BUILD;
  return `ver: ${git.version}-${git.branch} (${moment(time).format('YYYY-MM-DD HH:mm')})`;
}

export function parseLocalizedString(v) {
  // Check if the value is already in the desired format
  if (
    typeof v === 'object' &&
    v?.en !== undefined &&
    v?.['zh-hk'] !== undefined &&
    v?.['zh-cn'] !== undefined
  )
    return v;

  const out = new Map();
  out.set('en', v || '');
  out.set('zh-hk', v || '');
  out.set('zh-cn', v || '');

  try {
    // Try to parse the string value and only return if it has atleast one translation
    const parsedData = JSON?.parse(v);
    parsedData['zh-cn'] = parsedData['zh-cn'] || parsedData['zh-hk'] || v;
    parsedData['zh-hk'] = parsedData['zh-hk'] || parsedData['zh-cn'] || v;
    parsedData['en'] = parsedData['en'] || v;
    if (
      parsedData &&
      parsedData.en !== undefined &&
      parsedData['zh-hk'] !== undefined &&
      parsedData['zh-cn'] !== undefined
    )
      return parsedData;
  } catch (error) {
    // Transform the value to the LocalizeStringSchema format
    return Object.fromEntries(out);
  }

  // Transform the value to the LocalizeStringSchema format
  return Object.fromEntries(out);
}
